import {gql} from '@apollo/client';
import React from 'react';

import {useSkippableBenchlingQuery} from 'graphql-client/BenchlingQuery';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

import {TagSchemaFieldInputQuery} from './__generated/TagSchemaFieldInputQuery';
import BaseSchemaSubdependencyInput from './BaseSchemaSubdependencyInput';
import {ChildDependencyTypes} from './ChildDependencyTypes';

export const TAG_SCHEMA_FIELD_INPUT_QUERY = gql`
  query TagSchemaFieldInputQuery($id: StrictString!) @skipAudit {
    tagSchema(id: $id) {
      ... on TagSchemaNode {
        ...TagSchemaGraphQL
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('TagSchema').fragment}
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

export default function TagSchemaFieldInput({
  subdependencies,
  onChange,
  dependencyValidation,
  updateDependencyConfigValidation,
  disabled,
  parentDependencySelectedId,
}: ChildDependencyTypes): JSX.Element | null {
  const result = useSkippableBenchlingQuery<TagSchemaFieldInputQuery>(TAG_SCHEMA_FIELD_INPUT_QUERY, {
    skip: parentDependencySelectedId == null,
    variables: {id: parentDependencySelectedId},
  });
  return (
    <BaseSchemaSubdependencyInput<TagSchemaFieldInputQuery>
      subdependencies={subdependencies}
      onChange={onChange}
      dependencyValidation={dependencyValidation}
      updateDependencyConfigValidation={updateDependencyConfigValidation}
      disabled={disabled}
      result={result}
      getSchemaFromResult={(result) => result.data.tagSchema}
    />
  );
}
